export const TOWER_HEADING_OFFSET = 0;
export const ENEMY_HEADING_OFFSET = 0;
